import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { DcMaintainenceResponse } from '../../model/dc-maintainence-response';
import { Roles } from '../../model/roles';
import { SortableColumn } from '../../model/sort/sortable-column';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';

@Component({
    selector: 'app-dc-users',
    templateUrl: './dc-users.component.html',
    styleUrls: ['./dc-users.component.scss'],
    standalone: false
})
export class DcUsersComponent implements OnInit,AfterViewInit {
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  displayedColumns: string[] = ['upn', 'firstname', 'lastname',  'userrole', 'status', 'action'];
  dataSource: MatTableDataSource<UsersDataResponse>;
  dcNumbers: DcMaintainenceResponse[];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  user: UsersDataResponse;
  userData: UserData;
  dcUserForm: UntypedFormGroup;
  sortableColumn:SortableColumn;
  constructor(private router: Router,private route:ActivatedRoute, private userservice: UserService,private fb: UntypedFormBuilder) {
    
     this.sort=new MatSort();
   
     this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
      this.dcNumbers=this.user.dcLocations.filter(s=>s.roleId===2);
    })
    
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<UsersDataResponse>();
    this.route.params
    .subscribe(params => {
      let dcNumber = params['dcNumber'];
      this.createForm(dcNumber!==undefined?dcNumber:'');
      this.updateForm(parseInt(dcNumber));
    
    });
  }

  ngAfterViewInit() {
    this.getUsersData();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort=this.sort;
   
  //  this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
   
    
  }
  createForm(dcNumber) {
    this.dcUserForm = this.fb.group({
      dcNumber: [dcNumber, Validators.required],
      status: ['Y'],
     
      
    });

  }

  updateForm(dcNumber){
    this.dcUserForm.patchValue({
      dcNumber: dcNumber
    })
  }

  sortData(sort: Sort) {
    this.sortableColumn=new SortableColumn('','','');
    const sortedData: boolean | Array<any> = this.sortableColumn.sortTableData(sort, this.dataSource.data, this.displayedColumns);
    if (sortedData) {
      this.dataSource.data = sortedData as Array<any>;
    }
  }

 

getRoledID(roles:Roles[]){
  let roleId=[]
  roles.forEach(element => {
  roleId.push(element.roleIdAccess)
});
return roleId.toString();
}

  

  getUsersData() {
    if(this.dcUserForm.value.dcNumber)
    this.dataSource=new MatTableDataSource<UsersDataResponse>();
    
     merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
        
          return this.userservice!.getAllUsersByDC(this.dcUserForm.value.status,
            this.dcUserForm.value.dcNumber,'0',this.getRoledID(this.user.lstAccess),
            this.sort.active, this.sort.direction, this.paginator.pageIndex,this.paginator.pageSize);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;

          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.dataSource=new MatTableDataSource<UsersDataResponse>(data));
    
  }

  
applyFilter(filterValue: string) {
  filterValue = filterValue.trim(); // Remove whitespace
  filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
  this.dataSource.filter = filterValue;
}


  addUser(){
    this.router.navigate(['/dcn-esign/administration/add-edit-dc-user'],{ queryParams: { 'action': 'dc-user-add'}});
  }

  editUser(user:UserData) {
    this.router.navigate(['/dcn-esign/administration/add-edit-dc-user',user.sequenceNumber],{ queryParams: { 'action': 'dc-user-edit' ,'dcNumber':this.dcUserForm.controls.dcNumber.value}});
  }

}
